document.addEventListener("DOMContentLoaded", function () {
    function updateSubmenuPosition() {
        const navbar = document.querySelector(".header__inner.row");
        const submenus = document.querySelectorAll(".header__sub_menu");
        const announcementBar = document.querySelector(".announcement__area");

        if (navbar && submenus.length > 0) {
            const navbarHeight = navbar.offsetHeight;
            const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

            function adjustSubmenuPosition() {
                // Max number to substract from (46px) 
                const scrollY = window.scrollY;
                const offset = Math.min(scrollY, 46);
                
                submenus.forEach(submenu => {
                    submenu.style.top = `${navbarHeight + announcementBarHeight - offset}px`;
                });
            }

            adjustSubmenuPosition();
            window.addEventListener("scroll", adjustSubmenuPosition);
        }
    }

    updateSubmenuPosition();
    window.addEventListener("resize", updateSubmenuPosition);
});
